<template>
  <div class="Operation">
    <a
      class="li qq"
      href="https://admin.qidian.qq.com/static_proxy/b2b-qq/wpa-link/index.html#/person?uin=727941929"
      target="_blank"
    >
      <span class="icon"></span>
    </a>
    <el-popover trigger="hover" placement="left-start">
      <div class="li weixin" slot="reference">
        <div class="icon"></div>
      </div>
      <div class="contacts">
        <div class="text">关注微信公众号</div>
        <img class="img" :src="require('@/assets/images/icons/public1.jpg')" />
      </div>
    </el-popover>
    <el-popover trigger="hover" placement="left-start">
      <div class="li phone" slot="reference">
        <div class="icon"></div>
      </div>
      <div class="contact">
        <div class="p">联系电话：</div>
        <div class="text">02787688455</div>
        <div class="p">工作时间：</div>
        <div class="text">上午8:30-下午18:00</div>
      </div>
    </el-popover>
    <div class="li navTop" @click="navTop">
      <div class="icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Operation",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    navTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 可选，平滑滚动效果
      });
    },
  },
};
</script>
<style scoped lang="scss">
.contact {
  font-size: 14px;
  color: #333;
  .text {
    font-size: 12px;
    color: $primary;
  }
}
.contacts {
  text-align: center;
  .text {
    font-size: 14px;
    color: $primary;
    margin-bottom: 5px;
  }
  .img {
    width: 85px;
    height: 85px;
  }
}
.Operation {
  position: fixed;
  bottom: 25%;
  right: 30px;
  z-index: 2;
  .li {
    width: 40px;
    height: 40px;
    background-color: rgba(50, 50, 50, 0.5);
    border-radius: 50%;
    display: flex;
    margin-bottom: 10px;
    cursor: pointer;
    .icon {
      width: 30px;
      height: 30px;
      margin: auto;
    }
  }
  .qq {
    .icon {
      @include icons("@/assets/images/icons/QQ.png");
    }
  }
  .weixin {
    .icon {
      @include icons("@/assets/images/icons/weixin.png");
    }
  }
  .phone {
    .icon {
      @include icons("@/assets/images/icons/phone.png");
    }
  }
  .navTop {
    .icon {
      width: 25px;
      height: 25px;
      @include icons("@/assets/images/icons/navTop.png");
    }
  }
  .li:hover {
    background-color: $primary;
    @include transition;
  }
}
</style>
